import { Action } from '@ngrx/store';
import { EmissionPointsWithParametersView } from '../../../_generated';

export enum EmissionPointsAction {
  Load = '[EmissionPoints] Load',
  Get = '[EmissionPoints] Get',
  Reset = '[EmissionPoints] Reset',
}

export class Load implements Action {
  readonly type = EmissionPointsAction.Load;
}

export class Get implements Action {
  readonly type = EmissionPointsAction.Get;

  constructor(public payload: EmissionPointsWithParametersView[]) {}
}

export class Reset implements Action {
  readonly type = EmissionPointsAction.Reset;
}

export type EmissionPointsActionType = Load | Get | Reset;
